import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ArrowRight({ className, size = 24 }) {
    return (_jsxs("svg", { className: className, height: size, width: size, fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: [_jsx("path", { d: "M13.9774 5.93152L20.7959 12.75L13.9774 19.5686", strokeWidth: 1.4 }), _jsx("path", { d: "M19.4322 12.7501H1.70406", strokeWidth: 1.4 })] }));
}
export default ArrowRight;
